import { tw } from "@/shared/utils";

export const Skeleton = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={tw("animate-pulse rounded-md bg-secondary-200", className)}
      {...props}
    />
  );
};
